import cx from 'classnames'
import React, { type JSX } from 'react'
import styled, { css } from 'styled-components'

import type { InjectedProps } from '@material/react-ripple'
import * as ReactRipple from '@material/react-ripple'

import { complementaryColor, primaryColor } from 'uiComponents/constants/colors'
import * as styles from './styles.module.scss'

const withRipple = (
  'default' in ReactRipple
    ? // @ts-expect-error
      ReactRipple.default.withRipple
    : ReactRipple.withRipple
) as typeof ReactRipple.withRipple

interface IProps extends InjectedProps<any> {
  children?: React.ReactNode
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>
  className?: string
  rippleFit?: boolean
  rippleTheme?: 'light' | 'dark'
  onClick?: React.MouseEventHandler
  [key: string]: any
}

interface RippleStyleProps {
  rippleFit?: boolean
  rippleTheme?: 'light' | 'dark'
}

const RippleStyled = styled.div`
  display: inline-block;
  &.mdc-ripple-surface.mdc-ripple-upgraded {
    --mdc-ripple-fg-opacity: 0.25;
  }

  &.mdc-ripple-surface.mdc-ripple-upgraded--foreground-activation::after {
    animation-name: ${styles['mdc-ripple-fg-radius-in']},
      ${styles['mdc-ripple-fg-opacity-in']};
  }

  &.mdc-ripple-surface.mdc-ripple-upgraded--foreground-deactivation::after {
    animation-name: ${styles['mdc-ripple-fg-opacity-out']};
  }

  ${({ rippleTheme }: RippleStyleProps) => css`
    &.mdc-ripple-surface.mdc-ripple-upgraded::before,
    &.mdc-ripple-surface.mdc-ripple-upgraded::after {
      background-color: ${rippleTheme === 'dark'
        ? complementaryColor
        : primaryColor};
    }
  `};

  ${({ rippleFit }: RippleStyleProps) =>
    rippleFit
      ? css`
          &.mdc-ripple-surface.mdc-ripple-upgraded::before {
            top: var(--mdc-ripple-top, 0%);
            left: var(--mdc-ripple-left, 0%);
            width: var(--mdc-ripple-fg-size, 100%);
            height: var(--mdc-ripple-fg-size, 100%);
          }
        `
      : null};
`

const Ripple: React.FC<IProps> = ({
  children,
  initRipple,
  className,
  ...rest
}) => {
  const props = {
    ref: initRipple,
    className: cx('mdc-ripple-surface', className),
    ...rest,
  }
  return <RippleStyled {...props}>{children}</RippleStyled>
}

export default withRipple<IProps>(Ripple) as React.FC<IProps>
